import format from 'xml-formatter';

export const parseXml = (xmlString: string): Document => {

  return new DOMParser().parseFromString(xmlString, "text/xml");
}

export const formatXml = (elem: Element, indentText?: string): string => {
   return format(elem.outerHTML, {
      indentation: indentText,
      lineSeparator: '\n'
   });
}

